import React from "react";
import { withRouter } from "react-router-dom";

import Button from "@/components/UI/Button";

import "./PracticeFailure.styles.scss";

const PracticeFailure = () => {
  return (
    <>
      <div className="p-lg-5 p-3 my-5">
        <div className="fs-26 txt-pri mb-5 mt-5 text-center tw:font-bold">
          We’re sorry, something has gone wrong on our end.
        </div>
        <div className="text-center mt-5 mb-4 workflow-container-sm">
          <p className="grey-text pt-5 mt-5 mb-0 tw:font-bold">What could have caused this?</p>
          <p className="grey-text">You might have completed a screening in another location.</p>
        </div>
        <div className="text-center mt-4 mb-5 workflow-container-sm">
          <p className="grey-text mb-0 tw:font-bold">What can you do?</p>
          <p className="grey-text">Please look for a staff member to help you.</p>
        </div>
        <div className="text-center mt-4 mb-5 workflow-container-sm">
          <Button
            className="Btn Btn--pri Btn--sm-2 workflow-btn-lg mt-5"
            onClick={() => window.location.reload()}
            type="button"
          >
            Back to Home Screen
          </Button>
        </div>
      </div>
    </>
  );
};

export default withRouter(PracticeFailure);
